import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchMenuItemsMissingFiscalSetup } from '@/renderer/services/menuServicePaginated';
import type { MissingFiscalSetupFilterParams } from '@/renderer/types/pagination';

export function useMenuItemsMissingFiscalSetup(
  params: MissingFiscalSetupFilterParams,
) {
  return useQuery({
    queryKey: queryKeys.menu.missingFiscalSetup(params),
    queryFn: async () => {
      const result = await fetchMenuItemsMissingFiscalSetup(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch menu items missing fiscal setup',
        );
      }
      return result.data;
    },
    // A null/undefined outletId is a valid company-wide view (e.g. a super
    // user viewing "All Outlets"), not "not ready yet" — always enabled.
    placeholderData: keepPreviousData,
  });
}
